import { Chip } from "@mui/material";

const TRI_STATE_CHIP = {
  true: { label: "Yes", color: "success", variant: "filled" },
  false: { label: "No", color: "default", variant: "outlined" },
  null: { label: "Not evaluated", color: "default", variant: "outlined" },
};

const VERIFIED_CHIP = {
  true: { label: "Verified", color: "success", variant: "filled" },
  false: { label: "Not verified", color: "default", variant: "outlined" },
  null: { label: "Not evaluated", color: "default", variant: "outlined" },
};

function LocationLabelTriStateChip({ value, variant = "default" }) {
  const lookup = variant === "verified" ? VERIFIED_CHIP : TRI_STATE_CHIP;
  const key = value === true ? "true" : value === false ? "false" : "null";
  const chip = lookup[key];

  return <Chip size="small" label={chip.label} color={chip.color} variant={chip.variant} />;
}

export default LocationLabelTriStateChip;
